/* =========================================================================
   HOLY SPIRIT - PRODUCT CARD web component
   <hs-product-card> encapsula: quick add (Cart AJAX API), swap de imagen por
   swatch, toast premium. La wishlist ahora la gobierna el motor global
   (assets/hs-wishlist.js) via [data-hs-wish] — este componente ya no la toca,
   para tener una sola fuente de verdad (items enriquecidos + persistencia).
   Sin librerias externas. Integra con Shopify via /cart/add.js y /cart.js.
   ========================================================================= */
(function () {
  "use strict";
  if (window.customElements && customElements.get("hs-product-card")) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  function updateCartCount() {
    return fetch(ROOT + "cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var nodes = document.querySelectorAll("[data-hs-cart-count], .cart-count-bubble, [ref='cartBubbleCount']");
        nodes.forEach(function (n) { n.textContent = cart.item_count; });
        document.dispatchEvent(new CustomEvent("hs:cart:updated", { detail: cart }));
        return cart;
      })
      .catch(function () {});
  }
  window.HSUpdateCartCount = updateCartCount;

  var toastEl, toastTimer;
  function toast(message) {
    if (!toastEl) {
      toastEl = document.createElement("div");
      toastEl.className = "hs-toast";
      toastEl.setAttribute("role", "status");
      toastEl.innerHTML = '<span class="hs-toast__txt"></span><a class="hs-toast__link" href="' + ROOT + 'cart">View bag</a>';
      document.body.appendChild(toastEl);
    }
    toastEl.querySelector(".hs-toast__txt").textContent = message;
    requestAnimationFrame(function () { toastEl.classList.add("is-visible"); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove("is-visible"); }, 3400);
  }

  function HSProductCard() { return Reflect.construct(HTMLElement, [], HSProductCard); }
  HSProductCard.prototype = Object.create(HTMLElement.prototype);
  HSProductCard.prototype.constructor = HSProductCard;

  HSProductCard.prototype.connectedCallback = function () {
    this._qaBtn = this.querySelector("[data-hs-quickadd]");
    this._swatches = this.querySelectorAll("[data-hs-swatch]");
    this._primary = this.querySelector(".hs-card__img--primary");

    this._onQuickAdd = this._onQuickAdd.bind(this);
    this._onSwatch = this._onSwatch.bind(this);
    if (this._qaBtn) this._qaBtn.addEventListener("click", this._onQuickAdd);
    this._swatches.forEach(function (s) { s.addEventListener("click", this._onSwatch); }, this);
  };

  HSProductCard.prototype._onSwatch = function (e) {
    e.preventDefault();
    var s = e.currentTarget;
    var img = s.getAttribute("data-image");
    var vid = s.getAttribute("data-variant-id");
    if (img && this._primary) { this._primary.src = img; this._primary.srcset = ""; }
    if (vid) { this.dataset.variantId = vid; if (this._qaBtn) this._qaBtn.setAttribute("data-variant-id", vid); }
    this._swatches.forEach(function (o) { o.classList.remove("is-active"); });
    s.classList.add("is-active");
  };

  HSProductCard.prototype._onQuickAdd = function (e) {
    e.preventDefault();
    var btn = this._qaBtn;
    var id = btn.getAttribute("data-variant-id") || this.dataset.variantId;
    if (!id || btn.classList.contains("is-loading")) return;
    btn.classList.add("is-loading");
    btn.disabled = true;

    fetch(ROOT + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw d; });
        return r.json();
      })
      .then(function () {
        btn.classList.remove("is-loading");
        btn.classList.add("is-added");
        updateCartCount();
        toast("Added to bag");
        setTimeout(function () { btn.classList.remove("is-added"); btn.disabled = false; }, 2200);
      })
      .catch(function (err) {
        btn.classList.remove("is-loading");
        btn.disabled = false;
        toast((err && err.description) ? err.description : "Could not add to bag");
      });
  };

  if (window.customElements) {
    customElements.define("hs-product-card", HSProductCard);
  }
})();
